import { Challenge } from '../Types/Challenge';
import { getApiInstance } from './Api';

export class ChallengesApi {
  async getUserChallenges(): Promise<Challenge[]> {
    const response = await getApiInstance().get<any[]>('/challenges/user');
    return response.data.map((data) => new Challenge(data));
  }
}
